var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "star-icon",
    title: "star icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "star-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92383 1.28041L6.20438 6.52971L0.609685 6.5155C0.0200872 6.514 -0.225002 7.25824 0.252298 7.59856L4.78462 10.8329L3.04164 16.0747C2.85725 16.6275 3.49996 17.0882 3.97649 16.7449L8.49734 13.4949L13.0153 16.7485C13.4911 17.0896 14.1315 16.6311 13.9501 16.0798L12.2117 10.8365L16.7472 7.60599C17.2252 7.26567 16.9801 6.52142 16.3905 6.52216L10.7951 6.53263L9.07941 1.28181C8.91323 0.76197 8.14987 0.693152 7.92375 1.28181L7.92383 1.28041Z",
    fill: "url(#paint0_linear_269_3400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_3400",
    x1: 8.5,
    y1: 0.865723,
    x2: 8.5,
    y2: 16.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF01"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.525fc68f7814cf7920c3edb1e3236fd0.svg";
export { ForwardRef as ReactComponent };